import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import PreferredCourierServicesList from "./views/PreferredCourierServicesList";
import AccountPropertiesPanel from "../customers/panels/AccountPropertiesPanel";
import AccountHolderPropertiesPanel from "../customers/panels/AccountHolderPropertiesPanel";
import PanelHeaderItem from "../components/PanelHeaderItem";
import {List} from "immutable";

class PreferredCourierServicesPage extends Component {

  constructor(props) {
    super(props);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.state = {
      hasSelection: false,
      accountId: "",
      selectedPanelId: "account"
    }
  }
  
  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Preferred Courier Services per Account";

    return (
      <div className="ShippingPage PreferredCourierServices SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={false} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem label="Account" id="account" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem label="Account Holder" id="customer" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
        </div>
      </div>
    );
  }

  renderView(page) {
    return (
      <PreferredCourierServicesList 
        selectedId={this.state.selectedId}
        onSelectionChange={this.handleSelectionChange}
      />
    )
  }

  handleSelectionChange(selectedId, accountId) {
    this.setState({
      selectedId,
      hasSelection: true,
      accountId
    })
  }

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }  


  renderPanels(page) {
    if (this.state.selectedPanelId === "account") {
      return this.buildPanels(List([AccountPropertiesPanel]));
    } else {
      return this.buildPanels(List([AccountHolderPropertiesPanel]));
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case AccountPropertiesPanel:
        return <AccountPropertiesPanel
                key="AccountPropertiesPanel"
                expanded={true}
                accountId={this.state.accountId}
                hasSelection={this.state.hasAccountSelection}
                />
      case AccountHolderPropertiesPanel:
        return <AccountHolderPropertiesPanel
                key="AccountHolderPropertiesPanel"
                expanded={true}
                accountId={this.state.accountId}
                />
      default:
        return null;
    }
  }  

}

export default PreferredCourierServicesPage;